import { render } from "./MemorialSearch.vue?vue&type=template&id=634a2c74"
import script from "./MemorialSearch.vue?vue&type=script&lang=js"
export * from "./MemorialSearch.vue?vue&type=script&lang=js"

import "./MemorialSearch.vue?vue&type=style&index=0&id=634a2c74&lang=css"

import exportComponent from "/tmp/build_37390889/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__